import { render } from "./CalibrationTab.vue?vue&type=template&id=ebb6e824"
import script from "./CalibrationTab.vue?vue&type=script&lang=js"
export * from "./CalibrationTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/adelaplace/PycharmProjects/smartcast/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__